import { FilterContentsComponent } from './filter-contents/filter-contents.component';
import {Component, EventEmitter, Input, OnInit, ViewChild, OnDestroy} from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import {Subscription} from 'rxjs';
import {HasFilter} from './has-filter';


/**
 * This is the contents of a filter. This can be useful when trying to build out a pusher filter which has the same contents as
 * the table filters.
 *
 * @Input dateValue: this is the date value for date data types
 * @Output dateValueChange: this allows you to use two-way binding on date values
 *
 * @Input filterValue: this is a string value for string or enumeration data types
 * @Ouput filterValueChange: this allows you to use two-way binding on filter values
 *
 * @Input operation: this is the operation of the filter
 * @Output operationChange: this allows you to use two-way binding on operation
 *
 * @Output menuTrigger: this is triggered when an encapsulating menu should close
 *
 * REQUIRED @Input data: this is the data source being panelFiltered on
 * REQUIRED @Input dataType: this is the type of the data. Accepted values are string, date, and enumeration
 * REQUIRED @Input columnName: this is the name of the column your filtering on
 *
 * @Input clearFilterEvent: this is an event emitter that fires whenever the filter is cleared from outside the component.
 *
 * @Input columnIndex: used when filtering on string[] rather than objects
 * @Input enumerationValues: this is a list of strings that can be selected for enumeration data types
 *
 * @Input valueWidth: the width of the filter input. Defaults to 180px.
 * @Input operationMarginRight: the space to the right of the operation box. Defaults to 0px.
 * @Input floatLabel: whether or not labels should float above the input. Defaults to auto.
 * @Input fieldsMarginBottom: the size of the bottom margin. Defaults to 0px.
 * @Input showLabel: determines whether or not the label shows up. Defaults to true.
 *
 * @Output clickEvent: this event fires when the filter button is clicked
 * @Output filterChange: this event fires when the data have been changed by this component. The event is the data.
 * @Output filterOperationChange: this event fires when the operation has been changed by this component. The event is the operation.
 */
@Component({
  selector: 'filter',
  templateUrl: './filter.component.html',
  styleUrls: [
      './filter.component.css'
  ]
})
export class FilterComponent extends HasFilter implements OnInit, OnDestroy {

    // Properties

    @Input() clearFilterEvent: EventEmitter<any>;
    clearFilterSubscription: Subscription;

    @ViewChild('filterContents', { read: FilterContentsComponent, static: true }) filterContents: FilterContentsComponent;
    @ViewChild(MatMenuTrigger, { static: true }) trigger: MatMenuTrigger;

    // Class Functions

    // Methods
    filterInputFocus() {
        if (this.filterContents && this.filterContents.filterInputRef) {
            this.filterContents.filterInputRef.nativeElement.focus();
        }
    }

    openMenu(event?: any) {
        this.trigger.openMenu();
        this.filterInputFocus();
        if (event) {
            event.stopPropagation();
        }
    }

    ngOnInit(): void {
		if (this.clearFilterEvent) {
			this.clearFilterSubscription = this.clearFilterEvent.subscribe(() => {
				this.filterValue = '';
				this.dateValue = undefined;
				this.operation = '0';
			});
		}
    }

    ngOnDestroy() {
    	if (this.clearFilterSubscription) {
    		this.clearFilterSubscription.unsubscribe();
		}
	}
}
